<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label big-label">
					<label for="montant">Quel est votre diplôme le plus élevé ?</label>
					<custom-select :items="diplomas" :selected="diploma" @change="diploma=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label big-label">
					<label for="montant">En tant qu'investisseur, vous vous estimez : </label>
					<custom-select :items="levels" :selected="level" @change="level=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label big-label">
					<label for="montant">Depuis quand effectuez-vous des placements financiers ?</label>
					<custom-select :items="ages" :selected="age" @change="age=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label big-label">
					<label for="montant">Le climat économique de votre pays dans 3 ans sera :</label>
					<custom-select :items="countries" :selected="country" @change="country=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				Quel type de produit connaissez-vous ? (plusieurs réponses possibles)
			</div>
			<div class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in products" v-bind:key="key" @click="toggleTag(product, tag)" :class="{active: isActiveTag(product, tag), locked: isLocked(product, tag)}">
					{{ tag }}
				</div>
			</div>
			<div class="label solo">
				Sur quels produits avez-vous investi ? (plusieurs réponses possibles)
			</div>
			<div class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in investedProducts" v-bind:key="key" @click="toggleTag(investedProduct, tag)" :class="{active: isActiveTag(investedProduct, tag), locked: isLocked(investedProduct, tag)}">
					{{ tag }}
				</div>
			</div>
			<div class="label solo">
				Quels modes de gestion connaissez-vous ? (plusieurs réponses possibles)
			</div>
			<div class="ctn-tags row">
				<div class="tag" v-for="(tag, key) in managements" v-bind:key="key" @click="toggleTag(management, tag)" :class="{active: isActiveTag(management, tag), locked: isLocked(management, tag)}">
					{{ tag }}
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import { Diploma, Level, Age, Country, Product, InvestedProduct, Management } from '@/common/components/MyPatrimonialLandscape/data/Knowledge'
import { mapGetters } from 'vuex'

export default {
	name: 'Knowledge',
	components: {
		CustomSelect
	},
	data () {
		return {
			diplomas: Diploma,
			levels: Level,
			ages: Age,
			countries: Country,
			products: Product,
			investedProducts: InvestedProduct,
			managements: Management,
			diploma: null,
			country: null,
			level: null,
			age: null,
			product: [],
			investedProduct: [],
			management: []
		}
	},
	mounted () {
		this.diploma = this.estate.knowledge.diploma || this.diplomas[0]
		this.level = this.estate.knowledge.level || this.levels[0]
		this.age = this.estate.knowledge.age || this.ages[0]
		this.country = this.estate.knowledge.country || this.countries[0]
		this.product = Array.from(this.estate.knowledge.products) || []
		this.investedProduct = Array.from(this.estate.knowledge.investedProducts) || []
		this.management = Array.from(this.estate.knowledge.managements) || []
	},
	methods: {
		toggleTag (items, value) {
			if (value !== 'Aucun' || items.length === 0) {
				if (items.indexOf(value) === -1) {
					items.push(value)
				} else {
					items.splice(items.indexOf(value), 1)
				}
			}

			if (items.length > 1) {
				const key = items.indexOf('Aucun')
				if (key !== -1) {
					items.splice(key, 1)
				}
			}
		},
		isActiveTag (items, value) {
			return (items.indexOf(value) !== -1)
		},
		isLocked (items, value) {
			if (value !== 'Aucun') return false
			return (items.length > 0 && items.indexOf(value) === -1)
		},
		validate () {
			return new Promise((resolve, reject) => {
				resolve(true)
			})
		},
		save () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('storePatrimonial', {
					name: 'KNOWLEDGE',
					data: {
						diploma: this.diploma,
						level: this.level,
						age: this.age,
						country: this.country,
						products: this.product,
						investedProducts: this.investedProduct,
						managements: this.management
					},
					fromStart: false
				}).then(() => {
					resolve()
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="scss" scoped>
.form-ui.landscape-patrimonial-ui {
	.label.solo {
		margin-top: 2rem;
	}
}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/Knowledge.vue